import NProgress from 'nprogress';
import { useEffect, useMemo } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';
// hooks
import useTenantMode from '../hooks/useTenantMode';

// ----------------------------------------------------------------------

export function ProgressBarStyle() {
  const theme = useTheme();

  // Same color as the org/venue mode stripe, so a route-change flash reads
  // as "more of the same signal" instead of a jarring, unrelated color.
  const { color } = useTenantMode();

  return (
    <GlobalStyles
      styles={{
        '#nprogress': {
          pointerEvents: 'none',
          '& .bar': {
            // Sits right below the persistent tenant-mode stripe (top:0..3px)
            // so the two never fight for the exact same pixels.
            top: 3,
            left: 0,
            height: 2,
            width: '100%',
            position: 'fixed',
            zIndex: theme.zIndex.snackbar,
            backgroundColor: color,
            boxShadow: `0 0 2px ${color}`
          },
          '& .peg': {
            right: 0,
            opacity: 1,
            width: 100,
            height: '100%',
            display: 'block',
            position: 'absolute',
            transform: 'rotate(3deg) translate(0px, -4px)',
            boxShadow: `0 0 10px ${color}, 0 0 5px ${color}`
          }
        }
      }}
    />
  );
}

export default function ProgressBar() {
  NProgress.configure({
    showSpinner: false
  });

  useMemo(() => {
    NProgress.start();
  }, []);

  useEffect(() => {
    NProgress.done();
  }, []);

  return null;
}
